import { useEffect, useState } from 'react';
import { Business, fallbackBusiness, fetchBusiness } from '../services/BusinessService';

export interface UseBusiness {
  business: Business;
  loading: boolean;
}

/** Public business profile + brand for a channel (defaults merged, cached). */
export default function useBusiness(channelId?: string): UseBusiness {
  const [state, setState] = useState<{ id?: string; business: Business | null }>({ business: null });

  useEffect(() => {
    if (!channelId) return;
    let alive = true;
    fetchBusiness(channelId).then((b) => {
      if (alive) setState({ id: channelId, business: b });
    });
    return () => { alive = false; };
  }, [channelId]);

  const ready = !!channelId && state.id === channelId && state.business;
  return {
    business: ready ? (state.business as Business) : fallbackBusiness(channelId || ''),
    loading: !!channelId && !ready,
  };
}
